<ion-list class="content-width">
  @if (venue()?.integrations?.length) {
    @for (integration of venue()?.integrations; track $index) {
      <ion-item>
        <ion-label>{{ integration?.partner?.username | partnerName }}</ion-label>
        <ion-button size="default" (click)="deleteIntegrations(integration._id, i)" slot="end" fill="clear" color="danger">
          <ion-icon slot="icon-only" name="trash"></ion-icon>
        </ion-button>
      </ion-item>
    }
  } @else {
    <div class="ion-text-center ion-margin">
      <ion-text color="medium" >
        {{'This venue does not have any integrations' | translate}}
      </ion-text>
    </div>
  }

  <ion-button class="ion-margin" (click)="isIntegrationsModalOpen = true" expand="block" fill="clear" color="primary">
    {{'Add Integration' | translate}}
  </ion-button>

</ion-list>

<ion-modal 
  [initialBreakpoint]="1" 
  [breakpoints]="[0, 1]" 
  [isOpen]="isIntegrationsModalOpen" 
  (ionModalDidDismiss)="isIntegrationsModalOpen = false">
  <ng-template>
    <div class="wrapper">
      <h1>{{'Add Integration' | translate}}</h1>

      <ion-list>
        <form [formGroup]="integrationForm">
          <ion-item detail="false">
            <ion-select label="{{'Select partner' | translate}}" formControlName="partner" label-placement="stacked" interface="popover" placeholder="{{'Select partner' | translate}}">
              <ion-select-option value="playsight">{{'Playsight' | translate}}</ion-select-option>
              <ion-select-option value="tracktennis">{{'Track.Tennis' | translate}}</ion-select-option>
              <ion-select-option value="savemyplay">{{'Save My Play' | translate}}</ion-select-option>
              <ion-select-option value="microframe">{{'Microframe Sports' | translate}}</ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item detail="false">
            <ion-input type="text" label="{{'Token' | translate}}" labelPlacement="stacked" placeholder="{{'Enter your token here' | translate}}" formControlName="token"></ion-input>
          </ion-item>

          <ion-button (click)="addIntegration()" expand="block" class="ion-margin">
            {{'Submit' | translate}}
          </ion-button>
        </form>
      </ion-list>
    </div>
  </ng-template>
</ion-modal>